import { useEffect, useState } from "react"
import { LEVELS, DEFAULT_LEVEL } from "../utils.js"

const CONFIG_KEY = "math-solver-config"

const LOCALE_TO_REGION = { ru: "CIS", en: "USA" }

const detectedLang = ((typeof chrome !== "undefined" && chrome.i18n?.getUILanguage?.()) || "en").split("-")[0]
const defaultRegion = LOCALE_TO_REGION[detectedLang] || "USA"
const DEFAULTS = { region: defaultRegion, level: DEFAULT_LEVEL[defaultRegion] }

async function loadConfig() {
  try {
    const result = await chrome.storage.sync.get(CONFIG_KEY)
    const stored = result[CONFIG_KEY]
    const valid = stored && stored.region && LEVELS[stored.region] ? stored : null
    return { ...DEFAULTS, ...(valid || {}) }
  } catch {
    return DEFAULTS
  }
}

function saveConfig(config) {
  try {
    chrome.storage.sync.set({ [CONFIG_KEY]: config })
  } catch {}
}

export function useConfig() {
  const [config, setConfig] = useState(DEFAULTS)

  useEffect(() => {
    loadConfig().then((loaded) => {
      console.log("[EqSolve config] loaded", loaded)
      setConfig(loaded)
    })
  }, [])

  const setLevel = (level) => {
    setConfig((current) => {
      if (!current || current.level === level) return current
      const next = { ...current, level }
      console.log("[EqSolve config] level change", {
        before: current.level,
        after: next.level,
        region: current.region,
      })
      saveConfig(next)
      return next
    })
  }

  const setRegion = (region) => {
    setConfig((current) => {
      if (!current || current.region === region) return current
      const next = { region, level: DEFAULT_LEVEL[region] }
      console.log("[EqSolve config] region change", {
        before: { region: current.region, level: current.level },
        after: { region: next.region, level: next.level },
      })
      saveConfig(next)
      return next
    })
  }

  return { config, setLevel, setRegion }
}
